import {Routes} from '@angular/router';
import {isNotSignedInGuard} from '../guards/is-not-signed-in.guard';

export const authRoutes: Routes = [{
  path: 'auth',
  loadComponent: () => import('../layout/auth-layout/auth-layout.component').then(m => m.AuthLayoutComponent),
  children: [
    {
      path: 'login',
      loadComponent: () => import('../pages/auth/sign-in/sign-in.component').then(m => m.SignInComponent),
      canActivate: [isNotSignedInGuard],
    },
    {
      path: 'forget',
      loadComponent: () => import('../pages/auth/forget/forget.component').then(m => m.ForgetComponent),
      canActivate: [isNotSignedInGuard],
    }, {
      path: 'forget-confirm',
      loadComponent: () => import('../pages/auth/forget-confirm/forget-confirm.component').then(m => m.ForgetConfirmComponent),
      canActivate: [isNotSignedInGuard],
    }, {
      path: 'password',
      loadComponent: () => import('../pages/auth/password/password.component').then(m => m.PasswordComponent)
    }, {
      path: '**',
      redirectTo: 'login',
      pathMatch: 'full',
    }
  ]
}]
